export default __webpack_public_path__ + "locales/lv/Common.json?hash=8ef8b00bcb9561eba22ec7514a013219";